import { render, staticRenderFns } from "./ImgOplati.vue?vue&type=template&id=0f1d2306&"
import script from "./ImgOplati.vue?vue&type=script&lang=js&"
export * from "./ImgOplati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports